import { render, staticRenderFns } from "./GeneralLedgerDetails.vue?vue&type=template&id=38a7e6e4"
import script from "./GeneralLedgerDetails.vue?vue&type=script&lang=js"
export * from "./GeneralLedgerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports